<template>
  <div>
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5 mb-5">
        <CHeader
    data-aos-easing="linear"
    data-aos-duration="1500"
    id="el"
    class="navbars"
  >
    <CHeaderBrand class="mx-auto" href="https://www.pickiddo.com/home">
      <img
        src="../assets/img/icon/logoPickiddo.png"
        height="48px"
        class="m-2"
      />
    </CHeaderBrand>

    <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
      <template #toggler-content>
        <CIcon name="cil-justify-center" />
      </template>
      <CDropdownItem href="https://www.pickiddo.com/edtournament"
        ><img style="max-height:30px" src="../assets/img/icon/exam.png" />EDTOURNAMENT</CDropdownItem
      >
      <CDropdownItem href="https://www.pickiddo.com/home"
        >HOMEPAGE</CDropdownItem
      >
      <CDropdown toggler-text="Product" class="m-2" color="light">
        <CDropdownItem href="https://www.pickiddo.com/PickiddoTv"
          >PICKIDDO TV</CDropdownItem
        >
        <CDropdownItem href="https://www.pickiddo.com/IntroProduct"
          >School System</CDropdownItem
        >
      </CDropdown>
      <!-- <CDropdownItem href="https://www.pickiddo.com/PickiddoTv"
        >PICKIDDO TV</CDropdownItem
      >
      > -->
      <CDropdown toggler-text="Class" class="m-2" color="light">
        <CDropdownItem href="https://www.pickiddo.com/JoinClass"
          >Join Class</CDropdownItem
        >
        <CDropdownItem href="Package">Package</CDropdownItem>
      </CDropdown>
      <!-- <CDropdownItem href="https://www.pickiddo.com/JoinClass"
        >JOIN CLASS</CDropdownItem
      > -->
      <CDropdownItem href="https://www.pickiddo.com/Package"
        >PACKAGE</CDropdownItem
      >
      <CDropdownItem href="https://www.pickiddo.com/JoinClass"
        >JOIN CLASS</CDropdownItem
      >

      <CDropdownItem href="https://pickiddo.com/OnlineClass/#/Login"
        >Login</CDropdownItem
      >
      <CDropdownItem href="https://app.pickiddo.com"
        >Mobile Login</CDropdownItem
      >

      <CDropdown toggler-text="About" class="m-2" color="light">
        <CDropdownItem href="About">About Us</CDropdownItem>
        <!-- <CDropdownItem href="Package"
          >Package</CDropdownItem
        > -->
        <CDropdownItem href="Blog">Blog</CDropdownItem>
      </CDropdown>

      <!-- <CDropdown toggler-text="Register" class="m-2" color="danger" >
        <CDropdownItem href="https://pickiddo.com/OnlineClass/#/SignUpTutor" style="background:#f6c6c6;border-bottom:1px solid #eee"
          >Tutor</CDropdownItem
        >
        <CDropdownItem href="https://www.pickiddo.com/SearchTutor" style="background:#f6c6c6"
          >Parent/Student</CDropdownItem
        >
      </CDropdown>

      <CDropdownItem href="https://pickiddo.com/OnlineClass/#/Login">
        <CButton color="success" size="sm" shape="pill"
          >SIGN IN</CButton
        ></CDropdownItem
      > -->
      <CDropdownItem>
        <a
          href="#"
          onclick="doGTranslate('en|ms');return false;"
          title="Malay"
          class="glink nturl notranslate"
        >
          <!-- <img
            src="//advancedcellnet.com/teamwork/wp-content/plugins/gtranslate/flags/16/ms.png"
            height="20"
            width="20"
            alt="Malay"
          /> -->
          BM
        </a>
      </CDropdownItem>
      <CDropdownItem>
        <a
          href="#"
          onclick="doGTranslate('en|en');return false;"
          title="English"
          class="glink nturl notranslate"
        >
          <!-- <img
            src="//advancedcellnet.com/teamwork/wp-content/plugins/gtranslate/flags/16/en.png"
            height="20"
            width="20"
            alt="English"
          /> -->
          EN
        </a>
      </CDropdownItem>
    </CDropdown>

    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3"><a href="https://www.pickiddo.com/edtournament"><img style="max-height:80px" to="https://www.pickiddo.com/edtournament" src="../assets/img/icon/exam.png" /></a> </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink
          style="
            color: #fff;
            font-family: 'Montserrat', sans-serif;
            font-weight: bold;
            font-size: 15px;
            margin-top:-9px;
          "
          href="https://www.pickiddo.com/home"
        >
          Homepage
        </CHeaderNavLink>
      </CHeaderNavItem>

    </CHeaderNav>
  </CHeader>
        <br /><br /><br />
      </CRow>

      <CContainer>
        <div class="text-center d-sm-down-none">
          <CCol sm="12">
            <CRow>
              <CCol sm="4"
                ><img style="max-width: 100%" src="../assets/img/blog.svg"
              /></CCol>
              <CCol sm="8"
                ><img style="max-width: 100%" src="../assets/img/blog1.png" />
                <h3 class="custom-64px text-white text-center">
                  Info in your hands
                </h3>
                <h4 class="text-white text-left">
                  Our blog delivers valuable and informative content on various
                  aspects of education in Malaysia, including current updates on
                  the country's education system, policies, and strategies.
                </h4></CCol
              >
            </CRow>
          </CCol>
        </div>
      </CContainer>

      <CRow>
        <div class="card-custom-web" style="background: #fff">
          <CContainer>
            <CRow class="mt-3">
              <CCol sm="12">
                <br /><br />
                <h1 class="text-center">
                  Pelajar Boleh Belajar Sendiri Melalui <br />
                  Kelas-Kelas Online
                </h1>
                <h5 class="text-center mt-3">
                  Semakin berkembangnya teknologi, belajar tidak lagi hanya
                  bergantung pada bahan ajar di dalam kelas saja. Pelajar kini
                  dapat memanfaatkan kelas-kelas online yang tersedia di
                  berbagai platform untuk belajar sendiri di rumah.
                </h5>
              </CCol>

              <CCol sm="6" class="mt-3">
                <h3 class="text-left">
                  Keuntungan Belajar Sendiri Melalui Kelas-Kelas Online
                </h3>
                Belajar sendiri melalui kelas-kelas online memiliki banyak
                keuntungan, antara lain:
                <ul>
                  <li>
                    Pelajar dapat memilih material yang ingin dipelajari dengan
                    lebih fleksibel
                  </li>
                  <li>
                    Pelajar dapat belajar di mana saja dan kapan saja, tidak
                    terikat pada waktu dan tempat tertentu
                  </li>
                  <li>
                    Pelajar dapat mempelajari topik yang tidak diajarkan di
                    dalam kelas reguler
                  </li>
                  <li>
                    Selain itu, dengan adanya kelas-kelas online, pelajar dapat
                    memperluas pengetahuan dan keterampilan secara mandiri.
                  </li>
                </ul>
              </CCol>
              <CCol sm="6" class="mt-3">
                <img src="../assets/img/online.jpg" style="max-width: 100%" />
              </CCol>
              <CCol sm="6"></CCol>
              <CCol sm="6">
                <br />
                <h3>Inovasi dalam Platform Kelas Online</h3>
                Agar pelajar dapat lebih memanfaatkan kelas-kelas online,
                penyedia platform harus menyediakan inovasi-inovasi yang dapat
                membantu meningkatkan kualitas pembelajaran. Salah satu platform
                yang baru saja meluncurkan fitur baru adalah Pickiddo.
              </CCol>

              <CCol sm="6">
                <h3>Pickiddo Stream Service</h3>
                Pickiddo merupakan platform pembelajaran online yang menyediakan
                berbagai kelas dari berbagai bidang, seperti bahasa Inggris,
                matematika, sains, dan seni. Dengan meluncurkan Pickiddo Stream
                Service, platform ini menambah nilai tambah untuk pembelajaran
                pelajar.
                <br /><br />
                Setiap guru yang mengunggah video kelasnya ke Pickiddo Stream
                Service akan dapat melihat performa videonya sendiri. Hal ini
                dapat membantu guru untuk meningkatkan kualitas kelas yang
                diajarkan. Selain itu, pelajar yang menonton video tersebut juga
                dapat memberikan feedback untuk membantu meningkatkan kualitas
                video tersebut di masa depan.
                <br /><br />
                Dengan Pickiddo Stream Service, pembelajaran pelajar dapat lebih
                efektif dan efisien, serta kualitas pembelajaran dapat lebih
                terjamin. Jadi, tunggu apalagi? Segera manfaatkan kelas-kelas
                online yang tersedia di platform Pickiddo untuk meningkatkan
                pengetahuan dan keterampilanmu!
              </CCol>
              <CCol sm="6">
                <br />
                <img src="../assets/img/live.jpg" style="max-width: 100%" />
              </CCol>
            </CRow>
          </CContainer>
          >
        </div>
      </CRow>
    </div>

    <Footerlayout></Footerlayout>
  </div>
</template>
            
            
            
            
            <script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundBanner from "../assets/img/promodesign.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import _ from "lodash";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  name: "Login",
  components: {
    Mainlayout,
    Footerlayout,
  },
  data() {
    return {
      blog: [],
      detailForm: true,
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);

    if (window.location.hostname !== "www.pickiddo.com/Blog") {
      window.location.href = "https://www.pickiddo.com/Blog";
    }
  },
  async mounted() {
    this.GetBlog();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {},

  methods: {
    removeInlineStyles(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      const elements = div.querySelectorAll("*");
      elements.forEach((element) => {
        element.removeAttribute("style");
      });
      return div.textContent;
    },
    truncateText(text, limit) {
      if (text.length > limit) {
        return text.slice(0, limit) + "...";
      } else {
        return text;
      }
    },
    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    GetBlog() {
      this.$API
        .get(this.$ListBlog, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.blog = response.data;
            this.getPic(this.blog.Image);
          }
        });
    },
    getPic(item) {
      return "https://pickiddo.com/blogs/" + item.Image;
    },
    GoToDetail(BlogId) {
      this.$router.push("DetailBlog?blogId=" + BlogId);
    },
  },
};
</script>
                <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-header {
  /* background: rgb(23, 77, 124);
              background: linear-gradient(92deg, #174d7c, #1b7682);
              border-bottom: 0.01px solid #1a6783;
              border-bottom: 1px solid #636f83; */

  background: transparent;
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: "Montserrat", sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  font-family: "Montserrat", sans-serif;
}
label {
  font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
  font-family: "Montserrat";
  font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
  top: 0 !important;
  font-family: "Montserrat", sans-serif;
}

input {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
  -webkit-text-fill-color: white !important;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}

.js-click:active {
  background: #e8f4ff;
  border-radius: 20px;
  border: 1px solid #e8f4ff;
}

.js-click:focus {
  background: #e8f4ff;
  border-radius: 20px;
  border: 1px solid #e8f4ff;
}
</style>